import type { Logger } from '@wix/thunderbolt-becky-types'

export type BuilderAppVersion = { appId: string; version: string }
export type BuilderAppVersions = Array<BuilderAppVersion>

export const BUILDER_APP_SEPARATOR = ','
export const BUILDER_APP_VERSION_SEPARATOR = ':'

export const deStringifyBuilderApps = (logger: Logger, builderAppVersions?: string): BuilderAppVersions => {
	if (!builderAppVersions) {
		return []
	}

	return builderAppVersions.split(BUILDER_APP_SEPARATOR).map((exp) => {
		const [appId, version] = exp.split(BUILDER_APP_VERSION_SEPARATOR)
		if (!version) {
			logger.warn(`Builder app version is missing for app ${appId}`)
			return
		}
		return { appId, version: version.replace('^', '') }
	}).filter((builderApp) => builderApp !== undefined) as BuilderAppVersions
}
